import module from "@homer.core/module";
import ObserverSelector from "@homer.core/observer.selector";
import ObserverIntersection from "@homer.core/observer.intersection";
import ObserverRemoval from "@homer.core/observer.removal";

const observer = ObserverIntersection.obtain();
const storage = new WeakMap();
const priorities = {
    low: 0,
    medium: 1,
    high: 2,
};

const preload = (node, importance) => {
    node.getAttribute("content")
        .split(",")
        .forEach((name) => {
            module.preload(name.trim(), importance ?? undefined);
        });
};
const obtainState = (target, priority) => {
    let state = storage.get(target);

    if (!state) {
        state = {
            priority,
            uuid: null,
            pending: [],
            callback: null,
            intersecting: false,
        };
        state.callback = (intersecting) => {
            state.intersecting = intersecting;

            if (!intersecting) {
                return;
            }

            for (let i = 0; i < state.pending.length; i += 1) {
                const node = state.pending[i];

                preload(node, node.getAttribute("importance"));
            }

            state.pending.length = 0;
        };

        state.uuid = observer.observe(target, state.callback, state.priority);
        storage.set(target, state);

        if (target !== document.head && target !== document.body && target !== document.documentElement) {
            ObserverRemoval.obtain(target, () => {
                observer.unobserve(state.uuid);
                storage.delete(target);
            });
        }

        return state;
    }

    if (priorities[priority] > priorities[state.priority]) {
        observer.unobserve(state.uuid);
        state.priority = priority;
        state.uuid = observer.observe(target, state.callback, state.priority);
    }

    return state;
};

function process(nodes) {
    nodes.forEach((node) => {
        const importance = node.getAttribute("importance");
        const priority = importance === "critical" ? "high" : importance === "high" ? "medium" : "low";
        const state = obtainState(node.parentElement, priority);

        if (state.intersecting) {
            preload(node, importance);

            return;
        }

        state.pending.push(node);
    });
}

new ObserverSelector('meta[itemprop="preload"][content]', process).observe(document.documentElement, {
    childList: true,
    subtree: true,
});

export default true;
